// extracted by mini-css-extract-plugin
module.exports = {"blockTitleTextFull":"blockTitleTextFull-module--blockTitleTextFull--dy_ZK","blockTitleTextFull__titleText":"blockTitleTextFull-module--blockTitleTextFull__titleText--1W1Re"};